import { cn } from "../../utils/classnames.js";
import { jsx } from "react/jsx-runtime";
//#region src/components/atoms/card.tsx
const Card = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card",
		className: cn("gap-6 rounded-lg py-6 elevation-1 bg-card text-card-foreground flex flex-col border", className),
		...props
	});
};
const CardHeader = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card-header",
		className: cn(`
          gap-2 px-6
          [.border-b]:pb-6
          @container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start
          has-data-[slot=card-action]:grid-cols-[1fr_auto]
        `, className),
		...props
	});
};
const CardTitle = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card-title",
		className: cn("font-semibold leading-none", className),
		...props
	});
};
const CardDescription = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card-description",
		className: cn("text-muted-foreground text-sm", className),
		...props
	});
};
const CardAction = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card-action",
		className: cn("col-start-2 row-span-2 row-start-1 self-start justify-self-end", className),
		...props
	});
};
const CardContent = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card-content",
		className: cn("px-6", className),
		...props
	});
};
const CardFooter = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("div", {
		"data-slot": "card-footer",
		className: cn("px-6 [.border-t]:pt-6 flex items-center", className),
		...props
	});
};
//#endregion
export { Card, CardAction, CardContent, CardDescription, CardFooter, CardHeader, CardTitle };

//# sourceMappingURL=card.js.map